module.exports = __webpack_public_path__ + "img/geofisica3_4-3_1536.f59818f8.jpg";